module.exports = __webpack_public_path__ + "img/Seifenblasenkanone.383b1933.jpg";